export function isValidFileSrc(src: string): boolean {
  return (
    /^https:\/\/api-da\.wixmp\.com\//.test(src) ||
    /^https:\/\/(.+)\.deviantart\.net\//.test(src) ||
    /^https:\/\/(|images-)wixmp-ed30a86b8c4ca887773594c2\.wixmp\.com\//.test(
      src
    ) ||
    /^https:\/\/(|images-)wixmp-395331243bc2089e8c09c8d3\.wixmp\.com\//.test(
      src
    ) ||
    /^https:\/\/img-deviantart\.wixmp\.com/.test(src)
  );
}
